import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

export type RoleDetail = components['schemas']['UserRoleDto']

export const roleDetailQueryKey = (roleName: string | undefined) =>
  ['roles', 'detail', roleName] as const

async function fetchRoleDetail(roleName: string): Promise<RoleDetail> {
  const result = await client.GET('/v1/admin/user_roles/{role_name}', {
    params: { path: { role_name: roleName } },
  })
  return unwrapApiData(result, 'Failed to fetch role')
}

/** Fetches a single role together with its permission scopes. */
export function useRoleDetail(roleName: string | undefined) {
  const query = useQuery({
    queryKey: roleDetailQueryKey(roleName),
    queryFn: () => fetchRoleDetail(roleName as string),
    enabled: Boolean(roleName),
  })

  return {
    role: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
